import { Skeleton } from '@/ui/components/primitives/skeleton'
import { cn } from '@/shared/utils'

/**
 * Skeleton for itinerary view: mimics timeline/day cards.
 */
export function ItineraryViewSkeleton() {
  return (
    <div className="space-y-6">
      <div className="space-y-4">
        {[1, 2].map((i) => (
          <div
            key={i}
            className={cn(
              'rounded-lg border border-earth-200 bg-card p-6 space-y-4 animate-pulse'
            )}
          >
            <Skeleton className="h-5 w-32" />
            <Skeleton className="h-4 w-48" />
            <Skeleton className="h-20 w-full rounded-md" />
            <Skeleton className="h-12 w-full rounded-md" />
          </div>
        ))}
      </div>
    </div>
  )
}
